module.exports = __webpack_public_path__ + "static/media/happiness.40ee4c91.svg";